import React, { Component } from 'react';

import './styles/modalTinkoffLoanInfo.scss';
import {separate} from "../../../helpers/separate";

export default class ModalTinkoffLoanInfo extends Component {
  render() {
    const { modalInfo } = this.props;

    return (
      <div className="tinkoff-loan-info">
        <h2>Рассрочка без переплат</h2>
        <div className="tinkoff-loan-info__periods">
          {/*
          <div className="tinkoff-loan-info__periods__item">
            <b>4 мес</b>
            <hr/>
            <b>{separate(Math.ceil(modalInfo.amount / 4))}</b>
            <br/>₽/мес
          </div>
          */}
          <div className="tinkoff-loan-info__periods__item">
            <b>6 мес</b>
            <hr/>
            <b>{separate(Math.ceil(modalInfo.amount / 6))}</b>
            <br/>₽/мес
          </div>
          {/*
          <div className="tinkoff-loan-info__periods__item">
            <b>10 мес</b>
            <hr/>
            <b>{separate(Math.ceil(modalInfo.amount / 10))}</b>
            <br/>₽/мес
          </div>
          <div className="tinkoff-loan-info__periods__item">
            <b>12 мес</b>
            <hr/>
            <b>{separate(Math.ceil(modalInfo.amount / 12))}</b>
            <br/>₽/мес
          </div>
          */}
        </div>
      </div>
    )
  }
}